import { number, string, boolean, object, array, mixed } from "yup";
import { IForecastModifierConfig } from "modules/Forecast/models/ForecastModifierConfig";
import { DateTime } from "luxon";
import { SBTranslate } from "i18n";

export const forecastModifierConfigValidator = () => {
	const schema = object()
		.shape(
			{
				id: number().min(0).integer(),
				name: string().required(),
				active: boolean().required(),
				startDate: mixed<DateTime>()
					.typeError(SBTranslate("modifierRequired"))
					.required(),
				endDate: mixed<DateTime>()
					.typeError(SBTranslate("modifierRequired"))
					.required(),
				operationType: number().required(),
				modifier: number()
					.typeError(SBTranslate("modifierRequired"))
					.required()
					.positive()
					.moreThan(0, (v) => SBTranslate("modifierGreaterThanZero")),
				products: array().of(object().shape({})),
				categories: array().of(object().shape({})),
				stores: array().of(object().shape({})),
			},
			[]
		)
		.test(
			"products",
			SBTranslate("filterNotSelected"),
			function (value: any) {
				return [
					...value.products,
					...value.categories,
					...value.stores,
				].some((s) => s.status !== false);
			}
		);

	const validate = async (obj: IForecastModifierConfig) => {
		try {
			await schema.validate(obj, { abortEarly: false });
			return { isValid: true, errors: [] };
		} catch (e: any) {
			return {
				isValid: false,
				errors: e.inner.map((c: any) => ({
					field: c.path,
					message: c.message,
				})),
			};
		}
	};

	return {
		schema,
		validate,
	};
};
